import './Loading.scss';

const Loading = () => {
  return (
    <div className='Loading'>
      <div className='loading-spinner'></div>
    </div>
  );
}

export default Loading;